import { useEffect } from 'react';

/**
 * Lightweight per-route SEO updater (no external deps).
 * Updates document title, meta description, canonical and OG tags.
 */
const Seo = ({ title, description, path = '/' }) => {
  useEffect(() => {
    const base = 'https://www.satisfurnituresydney.com.au';
    const fullUrl = `${base}${path}`;

    if (title) document.title = title;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        const [key, val] = selector.replace(/[\[\]"]/g, '').split('=');
        el.setAttribute(key, val);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', 'content', description);
      setMeta('meta[property="og:description"]', 'content', description);
      setMeta('meta[name="twitter:description"]', 'content', description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', 'content', title);
      setMeta('meta[name="twitter:title"]', 'content', title);
    }

    setMeta('meta[property="og:url"]', 'content', fullUrl);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', fullUrl);
  }, [title, description, path]);

  return null;
};

export default Seo;
